import { useNotificationSocket } from "../hooks/useNotificationSocket";

const NotificationSocketBridge = () => {
  useNotificationSocket();
  return null;
};

export default NotificationSocketBridge;
